import './index.scss';
interface PropTypes {
    isShow: boolean
}
function SpinnerComponent (props: PropTypes) {
    const isShow = props.isShow;
    return (
        isShow ? (
            <div className='spinner-wrapper'>
                <div className = "square">
                    <img src="./images/logo.png" alt='logo'/>
                </div>
            </div>
        ) : null
    )
}

export default SpinnerComponent

